import React from "react";
import { Fragment } from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  simpleBox: {
    marginBottom: "10px",
  },
  title: {
    [theme.breakpoints.down("s")]: {
      fontSize: "16px",
    },
  },
  paragraph: {
    [theme.breakpoints.down("s")]: {
      fontSize: "10px",
    },
  },
}));
export default function SubItemVariation({ title, subItem, status }) {
  return (
    <OuterItemsContainer>
      <ItemTitle>{title}</ItemTitle>
      {<SimpleItems subItem={subItem} />}
      {status && <span>*{status}</span>}
    </OuterItemsContainer>
  );
}
const ItemTitle = ({ children }) => {
  const classes = useStyles();
  return (
    <Typography className={classes.title} variant="h3">
      {children}
    </Typography>
  );
};

const OuterItemsContainer = ({ children }) => {
  const classes = useStyles();
  return <Box className={classes.simpleBox}>{children}</Box>;
};

const SimpleItems = ({ subItem }) => {
  const classes = useStyles();
  return (
    <Typography className={classes.paragraph} variant="body1">
      {subItem &&
        subItem.map((item) => (
          <Fragment key={item._id}>{item.title},</Fragment>
        ))}
    </Typography>
  );
};
